import { FilterSettings, Participant, StatusName, TagName } from '@range.io/basic-types'
import { tagged } from '@range.io/functional'
import PropTypes from 'prop-types'
import React from 'react'
import FilterSelector from './filters/FilterSelector.js'

/*
 * FilterForCanvas select from about a dozen different filters
 * @sig FilterForCanvas = ({ LookupTable, LookupTable, FilterSettings, F) -> React component
 *  F = FilterSettings -> ()
 */
const FilterForCanvas = ({
    allCategories,
    allIdentifiers,
    allParticipants,
    allStatuses,
    allTags,
    projectIdentifier,
    filterSettings,
    setFilterSettings,
}) => {
    const groupStyles = {
        assignee: { ml: 16, mr: 16 },
        category: { ml: 16, mr: 16 },
        follower: { ml: 16, mr: 16 },
        overdue: { ml: 16, mr: 16, pl: 0, pr: 0 },
    }

    return (
        <FilterSelector
            allCategories={allCategories}
            allIdentifiers={allIdentifiers}
            allParticipants={allParticipants}
            allStatuses={allStatuses}
            allTags={allTags}
            filterSettings={filterSettings}
            dataCy="canvas-filter-button"
            filterTitle="Canvas Filters"
            groupStyles={groupStyles}
            projectIdentifier={projectIdentifier}
            setFilterSettings={setFilterSettings}
            showCanvasGroup={false}
            showPhotosGroup={true}
            tooltipText="Canvas Filters"
        />
    )
}

FilterForCanvas.propTypes = {
    allParticipants: PropTypes.arrayOf(tagged.typeIsRequired(Participant)).isRequired,
    allStatuses: PropTypes.arrayOf(tagged.typeIsRequired(StatusName)).isRequired,
    allTags: PropTypes.arrayOf(tagged.typeIsRequired(TagName)).isRequired,
    filterSettings: tagged.typeIsRequired(FilterSettings),
    setFilterSettings: PropTypes.func.isRequired,
}

export default FilterForCanvas
